const compare = require('./compare')
const gte = (a, b, loose) => compare(a, b, loose) >= 0
module.exports = gte



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/gte.js
// module id = 200
// module chunks = 1